import _extends from "@babel/runtime/helpers/extends";
import EmptyState from '@atlaskit/empty-state';
import { useFlags } from '@atlaskit/flag';
import { SpinnerMask } from '@atlassian/amkt-common';
import { GenericErrorImage, getFlagForError, getFlagForSuccess, TabHeader } from '@atlassian/developer-space';
import { updatePartnerDetails } from '@atlassian/mpac-api-client';
import { showModalIfTwoSVSessionExpires, useTwoStepAuthTimedOut } from '@atlassian/mpac-ui';
import { log } from '@atlassian/mpac-utils';
import React from 'react';
import { API_STATUS_ERROR_MESSAGE, GENERIC_ERROR_MESSAGE } from '../constants/ErrorMessages';
import PartnerAdminForm from './components/PartnerAdminForm';
import { getAdminUpdatePayload, getPartnerAdminFormFieldValues } from './utils';
const PartnerAdmin = _ref => {
  let {
    mpacBaseUrl,
    partnerId,
    partnerDetails
  } = _ref;
  const {
    showFlag
  } = useFlags();
  const {
    setTwoStepAuthTimedOut
  } = useTwoStepAuthTimedOut();
  if (partnerDetails.isPartnerDetailsRejected) {
    return /*#__PURE__*/React.createElement(EmptyState, {
      header: "We ran into a little trouble",
      description: "It might just be a hiccup. Try again in a bit.",
      imageUrl: GenericErrorImage
    });
  }
  const handleSubmit = async adminUpdatePayload => {
    try {
      await updatePartnerDetails(mpacBaseUrl, partnerId, getAdminUpdatePayload(adminUpdatePayload));
      showFlag(getFlagForSuccess('partner-admin-details-patch-success', 'Update successful', 'Your changes have been saved.'));
    } catch (error) {
      showModalIfTwoSVSessionExpires(error, setTwoStepAuthTimedOut);
      showFlag(getFlagForError('partner-admin-details-patch-failure', API_STATUS_ERROR_MESSAGE[error === null || error === void 0 ? void 0 : error.status] || GENERIC_ERROR_MESSAGE));
      log.error('Partner Admin', "Failed to update partner admin details", {
        error
      });
    } finally {
      partnerDetails.cancelPartnerDetails();
      partnerDetails.reloadPartnerDetails();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabHeader, {
    headerText: "Admin"
  }), /*#__PURE__*/React.createElement(SpinnerMask, {
    active: partnerDetails.isPartnerDetailsPending,
    size: 50
  }, partnerDetails.data && /*#__PURE__*/React.createElement(PartnerAdminForm, _extends({}, getPartnerAdminFormFieldValues(partnerDetails.data), {
    onSubmit: handleSubmit
  }))));
};
export default PartnerAdmin;